import Cookies from "js-cookie";
import * as Sentry from "@sentry/nextjs";

export const searchEmail = async (email: string): Promise<Record<string, unknown> | undefined> => {
  try {
    const response = await Promise.race([
      fetch(`https://person-stream.clearbit.com/v2/combined/find?email=${email}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer sk_748b9800f0fa17e17b9a93ed633412dd` },
      }),
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(undefined);
        }, 3000);
      }),
    ]);

    if (response) {
      // Promise.race will return undefined if the timeout is reached, so we need to cast the type here
      return await (response as Response).json();
    }

    return undefined;
  } catch (error) {
    Sentry.captureException(error);
    return undefined;
  }
};

export const isValidEmail = (email: string): boolean => {
  return Boolean(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/.test(
      email.toLowerCase(),
    ),
  );
};

export const submitHubSpotForm = async (
  formId: string,
  values: Record<string, string>,
  pageUri: string,
  gdprEnabled: boolean,
  gdprOptIn: boolean,
  sfdcCampaignId?: string,
): Promise<void> => {
  const portalId = "21018508";

  const hubspotUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;
  const hutkCookie = Cookies.get("hubspotutk");

  const fields = Object.entries(values).map(([name, value]) => ({
    objectTypeId: "0-1",
    name,
    value,
  }));

  // If the user is not in the EU, we don't need to ask for consent
  const gdprCompliance: boolean = gdprEnabled ? gdprOptIn : true;

  const body = JSON.stringify({
    fields: [...fields, { objectTypeId: "0-1", name: "gdpr_compliance", value: gdprCompliance }],
    sfdcCampaignId,
    pageUri,
    context: {
      hutk: hutkCookie,
      pageUri,
    },
    // Only include legal consent options if gdpr is a form field
    legalConsentOptions: {
      consent: {
        consentToProcess: true, // Process consent is implied through website usage in our Privacy Policy and on form submission.
        text: "I agree to allow Hightouch to store and process my personal data.",
        communications: [
          {
            value: gdprCompliance,
            subscriptionTypeId: 999,
            text: "I agree to receive other communications from Hightouch.",
          },
        ],
      },
    },
  });

  fetch(hubspotUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body }).catch((error) => {
    Sentry.captureException(error);
  });
};

export async function isGdprUser(): Promise<boolean> {
  return fetch("/api/gdpr-enabled", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then(async (result) => result.json())
    .then((result) => Boolean(result.gdprEnabled));
}
